import axios from 'axios'
import { Notification } from 'element-ui'
import store from '../store/store'
import $config from '../static/config'
import i18n from '../i18n/i18n'

export const notification = function (title, message, multiple) {
  if (!multiple) {
    Notification.closeAll()
  }
  Notification({
    title: title,
    message: message,
    duration: 3000,
    showClose: false
  })
}

// const $config.baseURL = process.env.VUE_APP_$config.baseURL
// const planURL = process.env.VUE_APP_PLANURL
axios.defaults.timeout = 200000

axios.interceptors.response.use(
  response => {
    return new Promise((resolve, reject) => {
      const data = response.data
      Notification.closeAll()
      resolve(data)
    })
  },
  error => {
    const status = error.response && error.response.status
    if (status === 401) {
      // notification('error', 'ERROR', 'Please make sure you are logged in!')
      // router.push({
      //   path: '/welcome/login'
      // })
      store.commit('userInfo', {})
      store.commit('mockUserInfo', {})
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

export function Get (url, params, hideErrorNotify, headers = {
  'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
  'Authorization': 'Bearer ' + store.state.userInfo.Token
}) {
  return new Promise((resolve, reject) => {
    axios.get($config.baseURL + url, {
      params: params,
      headers: headers
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        if (err.response.status !== 401 && !err.response.data.Data && (!hideErrorNotify || hideErrorNotify === false)) {
          notification(i18n.t('api.WARNING'), err.response.data.Message)
        }
        reject(err)
      })
  })
}

export function Post (url, params, hideSuccessNotify, config = {
  'headers': {
    'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
    'Authorization': 'Bearer ' + store.state.userInfo.Token
  }
}) {
  return new Promise((resolve, reject) => {
    axios.post($config.baseURL + url, params, config)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        if (err.response.status === 400 && url.indexOf('SetLicenseActive') === -1) {
          if (err.response.data.type && err.response.data.type.includes('application/json')) {
            let reader = new FileReader()
            reader.onload = function (event) {
              let content = reader.result
              let message = JSON.parse(content).Message
              notification(i18n.t('api.WARNING'), message)
            }
            reader.readAsText(err.response.data)
          } else {
            notification(i18n.t('api.WARNING'), err.response.data.Message)
          }
        }
        reject(err)
      })
  })
}

export function Put (url, params, config) {
  if (!config) {
    config = {}
  }
  return new Promise((resolve, reject) => {
    Object.assign(config, {
      'headers': {
        'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
        'Authorization': 'Bearer ' + store.state.userInfo.Token
      }
    })
    axios.put($config.baseURL + url, params, config)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        if (err.response.status === 400 && url.indexOf('SetLicenseActive') === -1) {
          if (err.response.data.type && err.response.data.type.includes('application/json')) {
            let reader = new FileReader()
            reader.onload = function (event) {
              let content = reader.result
              let message = JSON.parse(content).Message
              notification(i18n.t('api.WARNING'), message)
            }
            reader.readAsText(err.response.data)
          } else {
            notification(i18n.t('api.WARNING'), err.response.data.Message)
          }
        }
        reject(err)
      })
  })
}

export function Upload (url, params, config = {}) {
  return new Promise((resolve, reject) => {
    Object.assign(config, {
      'headers': {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + store.state.userInfo.Token
      }
    })
    axios.post($config.baseURL + url, params, config)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        if (err.response.status === 400 && url.indexOf('SetLicenseActive') === -1) {
          if (err.response.data.type && err.response.data.type.includes('application/json')) {
            let reader = new FileReader()
            reader.onload = function (event) {
              let content = reader.result
              let message = JSON.parse(content).Message
              notification(i18n.t('api.WARNING'), message)
            }
            reader.readAsText(err.response.data)
          } else {
            notification(i18n.t('api.WARNING'), err.response.data.Message)
          }
        }
        reject(err)
      })
  })
}

export function Delete (url, params, headers = {
  'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
  'Authorization': 'Bearer ' + store.state.userInfo.Token
}) {
  return new Promise((resolve, reject) => {
    axios.delete($config.baseURL + url, { data: params, headers }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

export function GetGzip (url, params, hideNotify, onDownloadProgress = {}, headers = {
  'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
  'Authorization': 'Bearer ' + store.state.userInfo.Token
}, requestType = 'arraybuffer') {
  return new Promise((resolve, reject) => {
    axios({
      url: $config.baseURL + url,
      method: 'get',
      data: params,
      headers: headers,
      onDownloadProgress: onDownloadProgress,
      responseType: requestType
    }).then(res => {
      resolve(res)
    }).catch(err => {
      if (!hideNotify) {
        notification(i18n.t('api.TIPS'), i18n.t('api.This project can not check on web'))
      }
      reject(err)
      console.log(err)
    })
  })
}

export function GetBlob (url, params, hideNotify, onDownloadProgress = {}, headers = {
  'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
  'Authorization': 'Bearer ' + store.state.userInfo.Token
}, requestType = 'blob') {
  return new Promise((resolve, reject) => {
    axios({
      url: $config.baseURL + url,
      method: 'get',
      data: params,
      headers: headers,
      onDownloadProgress: onDownloadProgress,
      responseType: requestType
    }).then(res => {
      resolve(res)
    }).catch(err => {
      if (!hideNotify) {
        notification(i18n.t('api.TIPS'), i18n.t('api.This project can not check on web'))
      }
      reject(err)
      console.log(err)
    })
  })
}

export function Login (params, headers = {
  'Content-Type': 'application/json;charset=UTF-8' // 设置跨域头部
}) {
  return new Promise((resolve, reject) => {
    axios.post($config.baseURL + '/api/Token', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        console.log(err.response)
        if (err.response.data && err.response.data.Status !== 102) {
          notification(i18n.t('api.WARNING'), i18n.t('api.' + err.response.data.Status))
        }
        reject(err)
      })
  })
}

export function Register (params, headers = {
  'Content-Type': 'application/json;charset=UTF-8' // 设置跨域头部
}) {
  return new Promise((resolve, reject) => {
    axios.post($config.baseURL + '/api/UserRegist', params)
      .then(res1 => {
        let data = {
          account: params.LoginAccount,
          pw: params.Password
        }
        axios.post($config.baseURL + '/api/Token', data).catch(function (error) {
          reject(error)
        })
      }).catch(err => {
        notification(i18n.t('api.WARNING'), err.response.data.Message)
        reject(err)
      })
  })
}

export function Forgot (params, headers = {
  'Content-Type': 'application/json;charset=UTF-8'
}) {
  return new Promise((resolve, reject) => {
    axios.post($config.baseURL + '/api/Forgot', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        notification(i18n.t('api.WARNING'), err.response.data.Message)
        reject(err)
      })
  })
}

export function HasMenuAction (roleId, actionId, headers = {
  'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
  'Authorization': 'Bearer ' + store.state.userInfo.Token
}) {
  return new Promise((resolve, reject) => {
    axios.get($config.baseURL + '/api/CorpRoles/' + roleId + '/CheckUiAuthority/' + actionId, {
      headers: headers
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function DownloadFileById (docFileId, responseType = 'blob') {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: $config.baseURL + '/api/Attachments/' + docFileId,
      responseType: 'blob',
      'headers': {
        'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
        'Authorization': 'Bearer ' + store.state.userInfo.Token
      }
    }).then(res => {
      resolve(res)
    })
      .catch(err => {
        reject(err)
      })
  })
}

export function getAvatarUrl (token) {
  return new Promise((resolve) => {
    axios({
      method: 'get',
      url: $config.baseURL + '/api/CorpUsers/Avatar',
      responseType: 'blob',
      'headers': {
        'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
        'Authorization': 'Bearer ' + token
      }
    }).then((res) => {
      let blob = new Blob([res])
      let objectUrl = URL.createObjectURL(blob)
      resolve(objectUrl)
    })
  })
}
